import { render, staticRenderFns } from "./crearAdministrador.vue?vue&type=template&id=35bea5a2&scoped=true&"
import script from "./crearAdministrador.vue?vue&type=script&lang=js&"
export * from "./crearAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./crearAdministrador.vue?vue&type=style&index=0&id=35bea5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bea5a2",
  null
  
)

export default component.exports